/** @jsxImportSource @emotion/react */
import React from 'react'

interface CheckmarkIconProps {
  size?: number
  color?: string
}

const CheckmarkIcon: React.FC<CheckmarkIconProps> = ({
  size = 16,
  color = '#F2B400',
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
  >
    <path
      d='M6.36667 11.7166C6.27778 11.7166 6.19444 11.7026 6.11667 11.6746C6.03889 11.647 5.96667 11.5999 5.9 11.5333L3.03333 8.6666C2.91111 8.54438 2.85267 8.38593 2.858 8.19127C2.86378 7.99705 2.92778 7.83882 3.05 7.7166C3.17222 7.59438 3.32778 7.53327 3.51667 7.53327C3.70556 7.53327 3.86111 7.59438 3.98333 7.7166L6.36667 10.0999L12.0167 4.44993C12.1389 4.32771 12.2973 4.2666 12.492 4.2666C12.6862 4.2666 12.8444 4.32771 12.9667 4.44993C13.0889 4.57216 13.15 4.73038 13.15 4.9246C13.15 5.11927 13.0889 5.27771 12.9667 5.39994L6.83333 11.5333C6.76667 11.5999 6.69444 11.647 6.61667 11.6746C6.53889 11.7026 6.45556 11.7166 6.36667 11.7166Z'
      fill={color}
    />
  </svg>
)

export default CheckmarkIcon
